import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer, ReferenceLine } from "recharts";

export default function StockChart({ candles = [], symbol }) {
  const data = candles.map((c) => ({
    t: c.t,
    close: c.c,
    high: c.h,
    low: c.l,
    open: c.o,
    volume: c.v,
  }));

  if (data.length === 0) {
    return (
      <div
        className="h-64 border border-white/10 bg-[#121215] flex items-center justify-center"
        data-testid="stock-chart-empty"
      >
        <span className="font-mono text-xs text-zinc-500 tracking-[0.2em] uppercase">
          No chart data
        </span>
      </div>
    );
  }

  const first = data[0]?.close;
  const last = data[data.length - 1]?.close;
  const up = (last ?? 0) >= (first ?? 0);
  const stroke = up ? "#34D399" : "#F87171";

  return (
    <div
      className="border border-white/10 bg-[#121215] p-4"
      data-testid={`stock-chart-${symbol}`}
    >
      <div className="flex items-center justify-between mb-3">
        <span className="font-mono text-[10px] tracking-[0.3em] text-zinc-500 uppercase">
          {symbol} · Daily Close
        </span>
        <span className={`font-mono text-xs ${up ? "text-green-400" : "text-red-400"}`}>
          {up ? "▲" : "▼"} {(((last - first) / first) * 100).toFixed(2)}%
        </span>
      </div>
      <div className="h-56">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={data} margin={{ top: 4, right: 8, left: 0, bottom: 0 }}>
            <XAxis
              dataKey="t"
              tick={{ fill: "#52525B", fontSize: 9, fontFamily: "JetBrains Mono" }}
              tickFormatter={(v) => (v ? v.slice(5) : "")}
              axisLine={{ stroke: "rgba(255,255,255,0.05)" }}
              tickLine={false}
              minTickGap={40}
            />
            <YAxis
              domain={["auto", "auto"]}
              tick={{ fill: "#52525B", fontSize: 9, fontFamily: "JetBrains Mono" }}
              axisLine={{ stroke: "rgba(255,255,255,0.05)" }}
              tickLine={false}
              width={48}
              tickFormatter={(v) => `$${v.toFixed(0)}`}
            />
            <Tooltip
              contentStyle={{
                background: "#0A0A0C",
                border: "1px solid rgba(255,255,255,0.2)",
                fontFamily: "JetBrains Mono",
                fontSize: 11,
                color: "#fff",
              }}
              labelStyle={{ color: "#A1A1AA" }}
              formatter={(v) => [`$${Number(v).toFixed(2)}`, "Close"]}
            />
            <ReferenceLine y={first} stroke="rgba(255,255,255,0.15)" strokeDasharray="3 3" />
            <Line
              type="monotone"
              dataKey="close"
              stroke={stroke}
              strokeWidth={1.6}
              dot={false}
              isAnimationActive={true}
            />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
